const showFeature = (envList) => {
  const currentEnv = process.env.REACT_APP_ENV;
  return envList.includes(currentEnv);
};

export default showFeature;
